import { render, staticRenderFns } from "./PowerBIReport.vue?vue&type=template&id=46ea716c&scoped=true"
import script from "./PowerBIReport.vue?vue&type=script&lang=js"
export * from "./PowerBIReport.vue?vue&type=script&lang=js"
import style0 from "./PowerBIReport.vue?vue&type=style&index=0&id=46ea716c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ea716c",
  null
  
)

export default component.exports